import { FILTER_TYPES } from "taltech-styleguide";

export const colName = {
  classes: "w-20",
  dataField: "name",
  sort: true,
  text: "Name",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-name"}>{col}</div>;
  },
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Name",
    type: FILTER_TYPES.TEXT,
  },
};

export const colFirstAndLastName = {
  classes: "w-20",
  dataField: "firstName",
  sort: true,
  text: "Name",
  formatter: (col: any, row: any, index: any, extraData: any) => {
    return <div className={"test-column-name"}>{`${row.firstName} ${row.lastName}`}</div>;
  },
  filterObject: {
    defaultValue: undefined,
    minChars: 3,
    placeholder: "Name",
    type: FILTER_TYPES.TEXT,
  },
};


export const colFirstName = {
  dataField: "firstName",
  sort: true,
  text: "First name",
};

export const colLastName = {
  dataField: "lastName",
  sort: true,
  text: "Last name",
};
